// 抛出登录请求状态
import {
	login,
	logout,
	getInfo,
	mobile_login,
	get_menu_list
} from '@/api/user'
// 抛出token状态
import {
	getToken,
	setToken,
	removeToken,
	setSession,
	getlocalStorage,
	setlocalStorage
} from '@/utils/auth'
const state = {
	token: getToken(),
	rubik_cube_id: '',
	mobile: '',
	home_mobile:'',
	home_role_name:'',
	home_name:'',
	username: '',
	company: '',
	email: '',
	avatar: '',
	cartnum: 0,
	balance: 0,
	points: 0,
	alipay_account: '',
	alipay_name: '',
	cash_money: '',
	auth_status: '',
	warning_value: '',
	is_warning: '',
	config: {},
	gz_openid: ''
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_MOBILE: (state, mobile) => {
		state.mobile = mobile
	},
	SET_NAME: (state, name) => {
		state.username = name
	},
	SET_COMPANY: (state, name) => {
		state.company = name
	},
	SET_EMAIL: (state, name) => {
		state.email = name
	},
	SET_AVATAR: (state, avatar) => {
		state.avatar = avatar
	},
	SET_CARTNUM: (state, cartnum) => {
		state.cartnum = cartnum
	},
	SET_BALANCE: (state, balance) => {
		state.balance = balance
	},
	SET_POINTS: (state, points) => {
		state.points = points
	},
	SET_ALIPAY_ACCOUNT: (state, alipay_account) => {
		state.alipay_account = alipay_account
	},
	SET_ALIPAY_NAME: (state, alipay_name) => {
		state.alipay_name = alipay_name
	},
	SET_CASH_MONEY: (state, cash_money) => {
		state.cash_money = cash_money
	},
	SET_AUTH_STATUS: (state, auth_status) => {
		state.auth_status = auth_status
	},
	SET_WARNING_VALUE: (state, warning_value) => {
		state.warning_value = warning_value
	},
	SET_IS_WARNING: (state, is_warning) => {
		state.is_warning = is_warning
	},
	SET_OPENID: (state, openid) => {
		state.gz_openid = openid
	},
	SET_HOME_MOBILE: (state, home_mobile) => {
		state.home_mobile = home_mobile
	},
	SET_HOME_ROLE_NAME: (state, home_role_name) => {
		state.home_role_name = home_role_name
	},
	SET_HOME_NAME: (state, home_name) => {
		state.home_name = home_name
	}
}

const actions = {
	// user login
	login({
		commit
	}, userInfo) {
		const {
			userName,
			password
		} = userInfo
		return new Promise((resolve, reject) => {
			login({
				mobile: userName.trim(),
				password
			}).then(response => {
				const {
					data
				} = response
				commit('SET_TOKEN', data.token)
				localStorage.setItem('ifRel', 0)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}
				
				setToken(data.token)
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	
	mobile_login({
		commit
	}, userInfo) {
		const {
			userName,
			sms_code
		} = userInfo
		return new Promise((resolve, reject) => {
			mobile_login({
				mobile: userName.trim(),
				sms_code
			}).then(response => {
				const {
					data
				} = response
				commit('SET_TOKEN', data.token)
				localStorage.setItem('ifRel', 0)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}
	
				setToken(data.token)
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	// get user info
	getInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getInfo().then(response => {
				const {
					data
				} = response

				if (!data) {
					reject('登录失效，请重新登录')
				}
				setSession('is_newcomer',JSON.stringify(data.is_newcomer) )
				get_menu_list({
					effect: 0
				}).then(res => {
					const {data} = res
					if (!data) {
					}
					const {menu_list} = data
					setSession('menu_list',JSON.stringify(res.data) )
				})
				get_menu_list({
					effect: 2
				}).then(res => {
					const {data} = res
					if (!data) {
					}
					const {menu_list} = data
					setSession('top_menu_list',JSON.stringify(res.data) )
				})
				commit('SET_MOBILE', data.mobile)
				commit('SET_HOME_MOBILE', data.home_shop_user_mobile)
				commit('SET_HOME_ROLE_NAME',  data.home_shop_user_role_name)
				commit('SET_HOME_NAME', data.home_shop_user_name)
				commit('SET_NAME', data.username)
				commit('SET_COMPANY', data.company)
				commit('SET_EMAIL', data.email)
				commit('SET_CARTNUM', data.cart_num)
				commit('SET_BALANCE', data.user_money)
				commit('SET_POINTS', data.points)
				commit('SET_ALIPAY_ACCOUNT', data.alipay_account)
				commit('SET_ALIPAY_NAME', data.alipay_name)
				commit('SET_CASH_MONEY', data.cash_money)
				commit('SET_AUTH_STATUS', data.auth)
				commit('SET_WARNING_VALUE', data.warning_value)
				commit('SET_IS_WARNING', data.is_warning)
				commit('SET_OPENID', data.gz_openid)
				if (data.avatar) {
					commit('SET_AVATAR', data.avatar)
				} else {
					// 默认头像
					commit('SET_AVATAR',
						'https://images.houniao.hk/houniao-images/shop/admin_image/upload/20220106/61d6acabc6f8c.png'
					)
				}
				if (data.auth == 0) {
					localStorage.setItem('ifRel', 1)
				}
				if (localStorage.getItem('ifRel') == 1 && data.auth == 1) {
					//重新登录
					localStorage.removeItem('ifRel')
					commit('SET_TOKEN', '')
					removeToken()
				}
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},
	


	// user logout
	logout({
		commit
	}) {
		return new Promise((resolve, reject) => {
			logout().then(() => {
				commit('SET_TOKEN', '')
				commit('SET_MOBILE', '')
				commit('SET_COMPANY', '')
				commit('SET_EMAIL', '')
				commit('SET_NAME', '')
				commit('SET_CARTNUM', '')
				commit('SET_BALANCE', '')
				commit('SET_POINTS', '')
				commit('SET_ALIPAY_ACCOUNT', '')
				commit('SET_ALIPAY_NAME', '')
				commit('SET_CASH_MONEY', '')
				commit('SET_AUTH_STATUS', '')
				commit('SET_WARNING_VALUE', '')
				commit('SET_IS_WARNING', '')
				commit('SET_AVATAR', '')
				commit('SET_OPENID', '')
				removeToken()
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	// remove token
	resetToken({
		commit
	}) {
		return new Promise(resolve => {
			commit('SET_TOKEN', '')
			commit('SET_MOBILE', '')
			commit('SET_COMPANY', '')
			commit('SET_EMAIL', '')
			commit('SET_NAME', '')
			commit('SET_CARTNUM', '')
			commit('SET_BALANCE', '')
			commit('SET_POINTS', '')
			commit('SET_ALIPAY_ACCOUNT', '')
			commit('SET_ALIPAY_NAME', '')
			commit('SET_CASH_MONEY', '')
			commit('SET_AUTH_STATUS', '')
			commit('SET_WARNING_VALUE', '')
			commit('SET_IS_WARNING', '')
			commit('SET_AVATAR', '')
			removeToken()
			resolve()
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
